import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";

const URL = process.env.REACT_APP_MICRO_PLANING_URL;

export const getEmissions = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/emission/radio${params.search ? params.search : ""}`, {
      params: { per_page: params.per_page, page: params.page },
    })
    .then((response) => {
      dispatch({
        type: "GET_EMISSIONS",
        data: response.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};
export const getPodacstForEmission = (id) => async (dispatch) => {
  await axios.get(`${URL}/podcast/emission/${id}`).then((response) => {
    dispatch({
      type: "GET_PODCAST_EMISSION_ID",
      podcastList: response.data.data,
    });
  });
};
export const getPodacstByEpisode = (episode_id) => async (dispatch) => {
  await axios.get(`${URL}/podcast/episode/${episode_id}`).then((response) => {
    dispatch({
      type: "GET_PODCAST_EPISODE_ID",
      podcastbyepisode: response.data?.data[0],
    });
  });
};
export const getEmissionById = (id) => (dispatch) => {
  axios.get(`${URL}/emissions/${id}`).then((response) => {
    dispatch({
      type: "GET_EMISSION_ID",
      emission: response.data.data[0],
    });
  });
};
export const addEmission = (emission, func, func1, params) => (dispatch) => {
  const data = new FormData();
  data.append("name", emission.name);
  data.append("description", emission.description);
  data.append("user_id", emission.user_id);
  data.append("is_radio_policy", emission.is_radio_policy);
  data.append("max_duration_sec", emission.max_duration);
  data.append("radio_id", emission.radio_id);
  data.append("language_id", emission.language_id);
  data.append("classification_id", emission.classification_id);
  data.append("tag_ids", JSON.stringify(emission.tag_ids));
  data.append("categorie_ids", JSON.stringify(emission.categorie_ids));
  emission.picture && data.append("picture", emission.picture);
  emission.credit_id && data.append("credit_id", emission.credit_id);
  emission.background_img &&
    data.append("background_img", emission.background_img);

  axios
    .post(`${URL}/emission/add`, data, {
      onUploadProgress: (progressEvent) => {
        let { loaded, total } = progressEvent;
        let percentComplete = loaded / total;
        percentComplete = parseInt(percentComplete * 100);
        func1(percentComplete);
      },
    })
    .then((res) => {
      dispatch({
        type: "ADD_EMISSION_SUCCESS",
        data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getEmissions(params));
    })
    .catch((err) => {
      if (err.response.data.message) {
        dispatch({
          type: "ADD_EMISSION_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_EMISSION_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const editEmission = (emission, func, func1, params) => (dispatch) => {
  const data = new FormData();
  data.append("name", emission.name);
  data.append("_method", emission._method);
  data.append("description", emission.description);
  data.append("user_id", emission.user_id);
  data.append("language_id", emission.language);
  data.append("classification_id", emission.classification);
  data.append("category_id", emission.category);
  data.append("is_radio_policy", emission.is_radio_policy);
  data.append("max_duration_sec", emission.max_duration);
  data.append("categorie_ids", JSON.stringify(emission.categorie_ids));
  data.append("tag_ids", JSON.stringify(emission.tag_ids));
  data.append("radio_id", emission.radio_id);
  emission.credit_id && data.append("credit_id", emission.credit_id);
  if (emission.picture !== null) {
    data.append("picture", emission.picture);
  }
  if (emission.background_img !== null) {
    data.append("background_img", emission.background_img);
  }

  axios
    .post(`${URL}/emissions/${emission.id}`, data, {
      onUploadProgress: (progressEvent) => {
        let { loaded, total } = progressEvent;
        let percentComplete = loaded / total;
        percentComplete = parseInt(percentComplete * 100);
        func1(percentComplete);
      },
    })
    .then((res) => {
      dispatch({
        type: "EDIT_EMISSION_SUCCESS",
        emission,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getEmissions(params));
    })
    .catch((err) => {
      if (err.response.data.message) {
        dispatch({
          type: "EDIT_EMISSION_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_EMISSION_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const deleteEmission = (id, params) => (dispatch) => {
  axios
    .delete(`${URL}/emissions/${id}`)
    .then((res) => {
      if (res.data.code === 200) {
        handleSuccessOne(res.data.message);
        dispatch(getEmissions(params));
      }
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};

export const getCommentByEmissionId = (id) => (dispatch) => {
  axios
    .get(`${URL}/emission/comment/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_COMMENT_BY_EMISSION",
        Comments: response.data.data,
        totalPages: response.data.data?.length,
      });
    })
    .catch((err) =>
      dispatch({
        type: "GET_COMMENT_BY_EMISSION",
        Comments: [],
        totalPages: 0,
      })
    );
};
export const addCommentByEmission = (data, id, func, params) => (dispatch) => {
  axios
    .post(`${URL}/emission/comment/${id}`, data)
    .then((res) => {
      dispatch({
        type: "ADD_COMMENT_EMISSION_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getCommentByEmissionId(id));
      dispatch(getEmissions(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_COMMENT_EMISSION_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_COMMENT_EMISSION_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getAllEmissionComments = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/emission/all-comments?page=${params?.page}`)
    .then((response) => {
      dispatch({
        type: "GET_ALL_EMISSIONS_COMMENTS",
        data: response.data.data?.data?.data,
        allData: response.data.data.allData,
        totalPages: response.data.data?.data?.total,
        params,
      });
    });
};
export const EditStatusComment =
  (idem, idcom, active, params) => (dispatch) => {
    const data = {
      active: active,
    };
    axios
      .put(`${URL}/emission/comment/${idem}/${idcom}`, data)
      .then((response) => {
        dispatch({
          type: "EDIT_STATUS_COMMENT_EMISSION_SUCCESS",
          payload: response.data,
        });
        {
          active === 0
            ? handleSuccessOne("comment status switched to Drafted ")
            : handleSuccessOne("comment status switched to Published");
        }
        dispatch(getAllEmissionComments(params));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_STATUS_COMMENT_EMISSION_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_STATUS_COMMENT_EMISSION_FAIL",
              payload: null,
            });
          }, 3000);
        }
      });
  };
export const getLastEmission = () => (dispatch) => {
  axios.get(`${URL}/emissions/last/5`).then((response) => {
    dispatch({
      type: "GET_LAST_EMISSION",
      Last: response?.data?.data,
    });
  });
};

export const getEmissioByCategorySlug = (
  slug,
  per_page,
  currentPage,
  dispatch,
  search
) => {
  axios
    .get(
      `${URL}/emissions/category/slug/${slug}/pagination/${per_page}${
        search ? search : ""
      }`,
      { params: { page: currentPage } }
    )
    .then((res) => {
      dispatch({
        type: "GET_EMISSION_BY_CATEGORY_SLUG",
        data: res.data.data.data,
        total: res.data.data.total,
      });
      dispatch({
        type: "EMISSION_PAGINATION_LAST_PAGE",
        lastPage: res.data.data.last_page,
      });
    });
};

export const getCategoryName = async (slug) => {
  const res = await axios.get(`${URL}/Categorie/${slug}`);
  return res.data.data[0];
};

export const getEmissioByTagSlug = (
  slug,
  per_page,
  currentPage,
  dispatch,
  search
) => {
  axios
    .get(
      `${URL}/emissions/tag/slug/${slug}/pagination/${per_page}${
        search ? search : ""
      }`,
      { params: { page: currentPage } }
    )
    .then((res) => {
      dispatch({
        type: "GET_EMISSION_BY_TAG_SLUG",
        data: res.data.data.data,
        total: res.data.data.total,
      });

      dispatch({
        type: "EMISSION_PAGINATION_LAST_PAGE",
        lastPage: res.data.data.last_page,
      });
    });
};

export const getEmissioByClassificationSlug = (slug, params) => (dispatch) => {
  axios
    .get(
      `${URL}/emissions/classification/${slug}/pagination/${params.per_page}${
        params.search ? params.search : ""
      }`,
      { params: { page: params.page } }
    )
    .then((res) => {
      dispatch({
        type: "GET_EMISSION_BY_CLASSIFICATION_SLUG",
        data: res.data.data.data,
        total: res.data.data.total,
        last_page: res.data.data.last_page,
        current_page: res.data.data.current_page,
      });
    });
};

export const getTagBySlug = async (slug) => {
  const res = await axios.get(`${URL}/Tag/${slug}`);
  return res.data.data[0];
};

export const getClassificationById = async (slug) => {
  const res = await axios.get(`${URL}/Classification/${slug}`);
  return res.data.data[0];
};
